var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTextAreaEditor)?_c('div',{ref:"textArea",staticClass:"textArea",style:(_vm.textAreaStyle),attrs:{"contentEditable":""},on:{"blur":_vm.onTextAreaBlur}},[_vm._v(_vm._s(_vm.currentTextContent))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }